import { useEffect } from 'react';

const isNumberInput = (element) =>
  element instanceof HTMLInputElement &&
  element.type === 'number' &&
  !element.disabled &&
  !element.readOnly;

const isWheelEventOnActiveField = (activeElement, eventTarget) => {
  if (!(eventTarget instanceof Element)) {
    return false;
  }

  const inputContainer = activeElement.closest('.MuiInputBase-root') || activeElement;
  return inputContainer.contains(eventTarget);
};

const useDisableNumberInputScroll = () => {
  useEffect(() => {
    const handleWheel = (event) => {
      const activeElement = document.activeElement;

      if (!isNumberInput(activeElement)) {
        return;
      }

      if (!isWheelEventOnActiveField(activeElement, event.target)) {
        return;
      }

      activeElement.blur();
    };

    document.addEventListener('wheel', handleWheel, true);

    return () => {
      document.removeEventListener('wheel', handleWheel, true);
    };
  }, []);
};

export default useDisableNumberInputScroll;
